var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { mergeDeepRight } from "ramda";
import { useCallback, useMemo } from "react";
import { itemId, listItemId } from "../use-search-reducer/reducers/types";
export var useIncludedItems = function (_a) {
    var criteria = _a.criteria, updateCriteria = _a.updateCriteria, include = _a.include, exclude = _a.exclude;
    var _b = include !== null && include !== void 0 ? include : {}, getIncludedItems = _b.getIncludedItems, setIncludedItems = _b.setIncludedItems;
    var _c = exclude !== null && exclude !== void 0 ? exclude : {}, getExcludedItems = _c.getExcludedItems, setExcludedItems = _c.setExcludedItems;
    var includedItems = useMemo(function () { return (getIncludedItems === null || getIncludedItems === void 0 ? void 0 : getIncludedItems(criteria)) || []; }, [criteria, getIncludedItems]);
    var excludedItems = useMemo(function () { return getExcludedItems === null || getExcludedItems === void 0 ? void 0 : getExcludedItems(criteria); }, [criteria, getExcludedItems]);
    var setIncluded = useCallback(function (items, numItems) { return __awaiter(void 0, void 0, void 0, function () {
        var newExcludedItems, included, excluded, newCriteria;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    newExcludedItems = excludedItems === null || excludedItems === void 0 ? void 0 : excludedItems.filter(function (t) { var _a; return (_a = items.findIndex(function (s) { return t[itemId] === s[itemId] && t[listItemId] === s[listItemId]; })) !== null && _a !== void 0 ? _a : -1 < 0; });
                    return [4 /*yield*/, setIncludedItems(criteria, items)];
                case 1:
                    included = _a.sent();
                    return [4 /*yield*/, setExcludedItems(criteria, newExcludedItems)];
                case 2:
                    excluded = _a.sent();
                    newCriteria = mergeDeepRight(included.criteria, excluded.criteria);
                    updateCriteria(newCriteria, { noPageReset: included.noPageReset || excluded.noPageReset }, undefined, numItems);
                    return [2 /*return*/];
            }
        });
    }); }, [criteria, excludedItems, setIncludedItems, setExcludedItems, updateCriteria]);
    var mergeIncludedItems = useCallback(function (items) { return __awaiter(void 0, void 0, void 0, function () {
        var itemsToInclude;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    itemsToInclude = items === null || items === void 0 ? void 0 : items.filter(function (t) { var _a; return (_a = includedItems === null || includedItems === void 0 ? void 0 : includedItems.findIndex(function (s) { return s[itemId] === t[itemId] && s[listItemId] === t[listItemId]; })) !== null && _a !== void 0 ? _a : -1 < 0; });
                    return [4 /*yield*/, setIncluded(__spreadArray(__spreadArray([], (itemsToInclude !== null && itemsToInclude !== void 0 ? itemsToInclude : []), true), (includedItems !== null && includedItems !== void 0 ? includedItems : []), true), itemsToInclude === null || itemsToInclude === void 0 ? void 0 : itemsToInclude.length)];
                case 1:
                    _a.sent();
                    return [2 /*return*/, itemsToInclude];
            }
        });
    }); }, [includedItems, setIncluded]);
    var includeSelected = useCallback(function (selection) { return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, mergeIncludedItems(selection)];
                case 1:
                    data = _a.sent();
                    return [2 /*return*/, data.map(function (item) { return item[listItemId]; })];
            }
        });
    }); }, [mergeIncludedItems]);
    var canInclude = !!setIncludedItems;
    return {
        includeSelected: canInclude ? includeSelected : undefined,
    };
};
//# sourceMappingURL=use-included-items.js.map